export default {
  labels: {
    reply: 'Răspunsul proprietarului',
  },
  form: {
    reply_text: {
      placeholder: 'Scrie răspunsul tău...',
    },
  },
  buttons: {
    generate_reply: 'Generează răspuns',
    submit_reply: 'Trimite răspunsul',
  },
  toasts: {
    failed_to_create_reply: 'Eroare la crearea răspunsului',
    failed_to_generate_ai_reply: 'Eroare la generarea răspunsului AI',
  },
};
